import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { post } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { PageHeader, Section } from "@/components/common/PageHeader";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const CATEGORIES = ["Travel", "Software", "Meals", "Equipment", "Other"];

export default function SubmitReimbursement() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { me } = useApp();
  const [form, setForm] = useState({ category: "", amount: "", description: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = useMutation({
    mutationFn: (body) => post("/hrms/leave/reimburse", body),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["leave"] }); toast.success("Reimbursement submitted"); navigate("/hrms/leave"); },
  });

  const go = () => {
    if (!form.category || !form.amount) { toast.error("Category and amount are required"); return; }
    submit.mutate({ ...form, amount: Number(form.amount), employee_id: me?.id, paid_out: false });
  };

  return (
    <div className="max-w-xl">
      <PageHeader title="Submit Reimbursement" subtitle="Claim an expense for reimbursement." />
      <Section>
        <div className="grid grid-cols-2 gap-4 p-4">
          <div>
            <Label>Category *</Label>
            <Select value={form.category} onValueChange={(v) => set("category", v)}>
              <SelectTrigger className="mt-1" data-testid="field-category"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div><Label>Amount *</Label><Input data-testid="field-amount" type="number" className="mt-1" value={form.amount} onChange={(e) => set("amount", e.target.value)} /></div>
          <div className="col-span-2"><Label>Description</Label><Textarea data-testid="field-description" className="mt-1" value={form.description} onChange={(e) => set("description", e.target.value)} /></div>
        </div>
      </Section>
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" onClick={() => navigate("/hrms/leave")}>Cancel</Button>
        <Button data-testid="submit-reimbursement" onClick={go} disabled={submit.isPending}>Submit Claim</Button>
      </div>
    </div>
  );
}
